exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  margin: 0px;\n  padding: 0px;\n  width: 100%; }\n\n.help-block {\n  font-size: 12px; }\n\n.card-in-card {\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 0;\n  background-color: #f0f3f5;\n  border-bottom: 1px solid #c2cfd6; }\n\npre.contents {\n  white-space: pre-wrap;\n  word-wrap: break-word; }\n\n.modal-header {\n  border-bottom: none; }\n\n.modal-content.recaptcha {\n  width: auto;\n  margin: auto; }\n\n:host ::ng-deep .mail-tooltip .tooltip-inner {\n  text-align: left;\n  max-width: 500px !important; }\n\n:host ::ng-deep .walkthrough-background {\n  position: fixed !important;\n  z-index: 1060 !important; }\n\n:host ::ng-deep .walkthrough-text-container {\n  top: 30px !important;\n  font-size: 22px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-consulter/form-consulter.component.scss
// module id = ../../../../../src/app/components/form-consulter/form-consulter.component.scss
// module chunks = main